<template>
  <div class="download-page uk-position-relative">
    <v-search
      :formContent="formContent"
      :SearchForm="SearchForm"
      :inline="true"
      @resetFn="resetFn"
      @searchFn="getListFn('search')"
      @confirmFn="getListFn('search')"
    >
      <template v-slot:bottom>
        <div class="d-p-btn">
          <div class="check">
            <el-checkbox
              border
              :indeterminate="indeterminate"
              v-model="checked"
              @change="change"
            ></el-checkbox>
          </div>
          <v-button
            @DelFn="DelFn"
            :optareBtn="optareBtn"
            v-bind="$attrs"
            v-on="$listeners"
          ></v-button>
        </div>
      </template>

      <IconDesc class="question" :icon-desc="iconDesc"></IconDesc>
    </v-search>
    <!-- table -->
    <TableContent
      ref="table"
      @handleSelect="handleSelect"
      @detailFn="detailFn"
      @downLoadFn="downLoadFn"
      :loading="loading"
      @getMore="getListFn"
      @rowFn="rowFn"
      :tableData="tableData"
      :load.sync="load"
    />
    <!-- detail -->
    <detailDialog
      :isShow.sync="isShow"
      :title="title"
      :detailObj="detailObj"
      @downloadFn="downLoadFn"
    />
  </div>
</template>

<script>
import mixinForm from '@/utils/formMixins.js'
import TableContent from './component/Table.vue'
import detailDialog from './component/detailDialog.vue'
import IconDesc from '../../../components/IconDesc/IconDesc.vue'
import bus from '@/utils/bus.js'
import {
  downloadDel,
  downloadDetail,
  downloadDownload,
  downloadList
} from '@/api/modules/download.js'
import { shareParam } from '@/api/modules/public.js'

export default {
  components: {
    TableContent,
    detailDialog,
    IconDesc
  },
  mixins: [mixinForm],
  data () {
    return {
      checked: false,
      indeterminate: false,
      choozeTable: [],
      statusArray: [],
      SearchForm: {
        name: null,
        time: [],
        format: null,
        status: null
      },
      iconDesc: [
        {
          title: $t('integration.file_type'),
          type: 'fileType'
        },
        {
          title: $t('integration.download_status'),
          type: 'downLoad'
        }
      ],
      formContent: [
        {
          id: 1,
          text: $t('integration.name'),
          type: 'input',
          paramsName: 'name',
          isChooze: true
        },
        {
          id: 2,
          text: $t('public.time'),
          type: 'datetimerange',
          paramsName: 'time',
          isChooze: false
        },
        {
          id: 3,
          text: $t('integration.export_type'),
          type: 'select',
          paramsName: 'format',
          isChooze: false,
          selectParam: []
        },
        {
          id: 4,
          text: $t('integration.state'),
          type: 'select',
          paramsName: 'status',
          isChooze: false,
          selectParam: []
        }
      ],
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['delRange'],
          text: 'buttonTitle.Delete',
          method: 'DelFn'
        }
      ],
      // 点击加载更多
      load: false,
      // 详情
      detailObj: {},
      timer: null
    }
  },
  created () {
    console.log(this.$store)
    this.getShareInitData()
    // 监听下载完成事件，自动刷新列表
    bus.$on('downloadComplete', this.onDownloadComplete)
  },
  beforeDestroy () {
    bus.$off('downloadComplete', this.onDownloadComplete)
  },
  methods: {
    // 下载完成时自动刷新列表
    onDownloadComplete () {
      this.tableData = []
      this.SearchForm.iDisplayStart = 0
      this.getListFn()
    },
    getShareInitData () {
      const P1 = shareParam({
        code: 'export_type',
        type: 0
      })
      const P2 = shareParam({
        code: 'export_status',
        type: 0
      })
      Promise.all([P1, P2]).then(res => {
        this.formContent.forEach(item => {
          if (item.id === 3) {
            item.selectParam = res[0].result.map(item => ({
              value: item.code,
              label: 'download.' + item.content
            }))
          }
          if (item.id === 4) {
            this.statusArray = item.selectParam = res[1].result.map(item => ({
              value: item.code,
              label: 'download.' + item.content
            }))
          }
        })
      })
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        time: [],
        format: null,
        status: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      this.tableData = []
      this.getListFn()
    },
    getListFn (str = '') {
      this.loading = true

      if (str === 'more') {
        this.SearchForm.iDisplayStart += 15
      } else if (str === 'search') {
        ;(this.tableData = []), (this.SearchForm.iDisplayStart = 0)
      }

      const query = { ...this.SearchForm }

      if (query.time.length > 0) {
        query.startTime = this.$dateParseTime(query.time[0])
        query.endTime = this.$dateParseTime(query.time[1])
        delete query.time
      }
      downloadList(query)
        .then(({ result, pageInfo }) => {
          this.tableData = this.tableData.concat(result)
          this.total = pageInfo.total
          if (
            pageInfo.total === this.tableData.length ||
            this.tableData.length < 15
          ) {
            this.load = true
          } else {
            this.load = false
          }
        })
        .finally(() => {
          this.indeterminate = false
          this.checked = false
          this.loading = false
        })
    },
    rowFn (ids) {
      this.TODOFN(ids.split(','))
    },
    DelFn (val) {
      if (this.choozeTable.length === 0 && !val) {
        return this.$message.warning(
          $t('integration.select_at_least_one_piece_of_data')
        )
      }
      let flag = false

      flag = this.choozeTable.some(item => item.status === 0)

      if (flag) {
        return this.$message.warning(
          $t('integration.only_generated_and_failed_records_can_be_deleted')
        )
      }

      const ids = this.choozeTable.map(item => item.id)
      this.TODOFN(ids)
    },
    TODOFN (ids) {
      this.$confirm(
        this.$t(
          $t(
            'integration._quo_this_operation_will_permanently_delete_this_information_dot__are_you_sure_you_want_to_do_this_q_quo_'
          )
        )
      )
        .then(() => {
          downloadDel(ids).then(({ result, state }) => {
            if (result === 200 && state.code === 200) {
              this.$message.success($t('integration.successfully_deleted'))

              this.getListFn('search')
            } else {
              this.$message.error($t('integration.delete_failed'))
            }
          })
        })
        .catch(() => {})
    },
    // 处理半选\全选状态
    handleSelect ({ isIndeterminate, checkAll, checkArray }) {
      this.indeterminate = isIndeterminate
      this.checked = checkAll

      this.choozeTable = [...checkArray]
    },
    // 下载
    downLoadFn (row) {
      this.$loading.show({
        text: this.$t('public.downloading')
      })
      downloadDownload(
        { id: row.id },
        row.name,
        row.format === 0 ? 'xlsx' : 'pdf'
      )
        .then(({ result }) => {
          if (result === 400) {
            this.$message.error(
              $t('integration.download_failed_c__parameter_error')
            )
            this.tableData = []
            this.getListFn()
          } else if (result === 401) {
            this.$message.error(
              $t('integration.download_failed_c__the_file_does_not_exist')
            )
            this.tableData = []
            this.getListFn()
          } else if (result === 402) {
            this.$message.error(
              $t('integration.download_failed_the_file_has_been_deleted')
            )
            this.tableData = []
            this.getListFn()
          }
        })
        .finally(() => {
          this.$loading.hide()
          this.isShow = false
        })
    },
    // 详细
    detailFn (row) {
      this.isShow = true
      this.title = row.name
      downloadDetail({ id: row.id }).then(({ result }) => {
        console.log(this.statusArray)
        this.statusArray.forEach(item => {
          if (Number(item.value) === result.status) {
            result.statusName = this.$t(item.label)
          }
        })
        console.log(result)
        this.detailObj = { ...result }
      })
    },
    change (bool) {
      if (this.indeterminate) {
        this.checked = true
        this.indeterminate = false
      }
      this.$refs.table.change(bool)
    }
  }
}
</script>

<style lang="scss" scoped>
.download-page {
  padding: 15px;
  padding-top: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .d-p-btn {
    display: flex;
    align-items: center;

    .check {
      height: 30px;
      width: 30px;
      // border: 1px solid var(--primary-color);
      margin-left: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;

      ::v-deep .el-checkbox.is-bordered.el-checkbox--mini {
        height: 30px;
      }
    }
  }

  ::v-deep .el-checkbox__inner {
    width: 14px !important;
    height: 14px !important;
  }

  .question {
    position: absolute;
    right: 20px;
    top: 65px;
  }
}
</style>
